export default {
  set(name, mbti, order) {
    this.mbti = mbti.toUpperCase()
    this.name = name
    this.order = order
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js